export const TREE_PANEL_DRAG_DROP_NODE_ID = 'TREE_PANEL_DRAG_DROP_NODE_ID'
